module.exports = __webpack_public_path__ + "static/media/fish.3d66a47b.png";